import React from "react";
import { Link } from "react-router-dom";
import { useSiteData } from "@/context/SiteDataContext";
import Title from "@/components/shared/Title";
import { FaEye } from "react-icons/fa";
import usePageMetadata from "@/lib/usePageMetadata";
import BlogCard from "@/components/shared/BlogCard";

function Blogs() {
  const { siteData, loading } = useSiteData();
  const blogs = siteData?.blogs || [];

  usePageMetadata(
    "Blogs | BioStat",
    "Explore the blogs we offer to support your medical research journey.",
  );

  if (loading)
    return <p className="py-10 text-center">Loading blog posts...</p>;

  return (
    <section className="px-4 py-12 text-center md:px-12 xl:px-16">
      <div className="flex flex-col items-center">
        <Title title="Our Blogs" className="mb-6 xl:mb-12" />
      </div>

      <h2 className="text-dark mb-6 text-2xl font-medium md:text-4xl xl:mb-12">
        Explore expert tips and updates in <br className="hidden xl:block" />
        research and statistics.
      </h2>

      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2 lg:grid-cols-3">
        {blogs.slice(0, 6).map((blog, index) => (
          <BlogCard key={index} blog={blog} /> // Using BlogCard component
        ))}
      </div>
    </section>
  );
}

export default Blogs;
